module.exports = __webpack_public_path__ + "media/src/img/list_main-335105fcfa93262ffb4bd699fc64c506.svg";